import { Box } from '@mui/material';
import { forwardRef, useEffect, useState } from 'react';
import { buildIframeSandboxAttribute } from '@/utils/buildIframeSandbox';
import type { EmbeddedApplication } from '@/types/embeddedApplication';

interface EmbeddedFrameProps {
  application: EmbeddedApplication;
  src: string;
  reloadToken: number;
  title: string;
  onLoad: () => void;
  onError: () => void;
}

export const EmbeddedFrame = forwardRef<HTMLIFrameElement, EmbeddedFrameProps>(
  function EmbeddedFrame(
    { application, src, reloadToken, title, onLoad, onError },
    ref,
  ) {
    const [shouldMount, setShouldMount] = useState(false);

    useEffect(() => {
      const frameId = window.requestAnimationFrame(() => {
        setShouldMount(true);
      });

      return () => {
        window.cancelAnimationFrame(frameId);
      };
    }, []);

    const sandbox = buildIframeSandboxAttribute(application.sandbox);

    return (
      <Box
        component="iframe"
        ref={ref}
        key={`${application.id}-${src}-${reloadToken}`}
        src={shouldMount ? src : undefined}
        title={title}
        onLoad={onLoad}
        onError={onError}
        allow="local-network-access *"
        allowFullScreen={application.allowFullscreen !== false}
        sandbox={sandbox}
        loading="lazy"
        sx={{
          width: '100%',
          height: '100%',
          border: 'none',
          display: 'block',
          bgcolor: 'background.paper',
        }}
      />
    );
  },
);
